<template>
  <div class="NewBg">
        <header class="index-head">
            <p class="name">最新报告</p>
            <p class="msg">
              <span v-for="(item,index) in msgList" :key="index" @click="routeSearch(item.name, item.code, item.code2)">{{item.name}}</span>
            </p>
            <p class="more" @click="routeSearch()">更多 ></p>
        </header>
        <div class="content">
            
            <div class="screen"> 
                <div class="screen-head">
                  <span>筛选条件</span>
                  <el-button type="text" :class="{active: screenActive == 'select'}" @click="screenType('select')">{{industrycode2Text}} <i :class="{'el-icon-arrow-down': screenActive !== 'select', 'el-icon-arrow-up': screenActive == 'select'}"></i></el-button>
                  <el-button type="text" :class="{active: screenActive == 'type'}" @click="screenType('type')">{{feetypeText}} <i :class="{'el-icon-arrow-down': screenActive !== 'type', 'el-icon-arrow-up': screenActive == 'type'}"></i></el-button>
                  <el-button type="text" :class="{active: screenActive == 'year'}" @click="screenType('year')">{{datetimeText}} <i :class="{'el-icon-arrow-down': screenActive !== 'year', 'el-icon-arrow-up': screenActive == 'year'}"></i></el-button>
                </div>
                <div class="screen-msg" data-mcs-theme="dark" v-show="screenActive !== ''" >
                  
                  <div v-show="screenActive == 'select'">
                    <p><span @click="tabType('全部行业', '')">全部行业</span></p>
                    <p v-for="(item, index) in classtype" :key="index">
                      <span v-for="(items, index) in item.content" :key="index" @click="tabType(items.name, items.code)">{{items.name}}</span>
                    </p>
                  </div>
                  <div v-show="screenActive == 'type' || screenActive == 'year'">
                    <span v-for="(items, index) in classtype" :key="index" @click="tabType(items.name, items.code)">{{items.name}}</span>
                  </div>
                </div>
            </div>
            <!-- 筛选 end -->

            <div class="new-list"  data-mcs-theme="dark">
              <div class="null" v-if="!newreportlist || newreportlist.length == 0">
                <img src="../../../../common/images/search/search-null.png" alt="">
                <p>当前类型暂无报告，请选择其它类型</p>
              </div>
              <div class="new-list-content" v-else>
                <div class="new-item" v-for="(item, index) in newreportlist" :key="index"  @click="routedetails(item.innerid)">
                    <div class="bg-img">
                      <img v-lazy="item.coverurl" :alt="item.subject">
                    </div>
                    <div class="new-item_text">
                      <p class="name">{{item.subject}}</p>
                      <p class="msg">{{item.repintro}}</p>
                      <p class="tag"><i class="type"></i>{{item.industryname}} {{item.industryname2}}</p>
                    </div>
                </div>
              </div>
            </div>
            <!-- 列表详情 end -->

        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import $ from 'jquery'
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js'
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css'
import types from './type.json' // 分类
export default {
  name: 'NewBg',
  props: ['newreportlist'],
  data () {
    return {
      screenActive: '',  // 筛选条件
      classtype: '',  // 类型
      industrycode2: '',  // 二级分类代码
      industrycode2Text: '行业选择',
      feetype: '',  // 费用类型（1免费 2收费）
      feetypeText: '报告类型',
      datetime: '', // 报告年份(格式 yyyy-MM-dd)
      datetimeText: '报告年份',
      msgList: [// 类别
        {name: "金融", code2: "0101", code: "01"},
        {name: "基金", code2: "0103", code: "01"},
        {name: "商业计划书", code2: "0304", code: "03"},
        {name: "股权激励", code2: "2506", code: "25"},
        {name: "大数据", code2: "2302", code: "23"},
        {name: "物联网", code2: "2303", code: "23"},
        {name: "游戏", code2: "0601", code: "06"},
        {name: "互联网运营", code2: "0507", code: "05"},
        {name: "行业分析", code2: "0406", code: "04"},
        {name: "在线教育", code2: "0803", code: "08"}
      ]
    }
  },
  mounted () {
    $('.new-list').mCustomScrollbar()
  },
  methods: {
    screenType(type) {  // 筛选条件
        
        if (this.screenActive == type) { // 点击元素相同，则为关闭
          this.screenActive = ''
          this.classtype = ''
        } else {
          this.screenActive = type

          switch(type) {  
            case "select":
                this.classtype = types
                this.$nextTick(() => {
                  $('.screen-msg').mCustomScrollbar()
                })
              break;
            case "type":
                this.classtype = [{name: '全部类型', code: ''},{name: '免费', code: '1'},{name: '收费', code: '2'}]
              break;
            case "year":
              this.classtype = [{name: '全部年份', code: ''},{name: '2020年', code: '2020'},{name: '2019年', code: '2019'},{name: '2018年', code: '2018'},{name: '2017年', code: '2017'},{name: '2016年', code: '2016'}]
              break;
          }
        }
    },
    routeSearch(name,code, code2) {
      this.$router.push({name:"ReportSearch", query:{catecode: code, typeData:code2, title: name}})
    },
    tabType(name, code) { // 切换类型
      switch(this.screenActive) {
            case "select":
              this.industrycode2 = code
              this.industrycode2Text = name
              break;
            case "type":
              this.feetype = code
              this.feetypeText = name
              break;
            case "year":
              this.datetime = code
              this.datetimeText = name
              break;
          }
      // 调用列表查询接口
      this.$parent.getIndexReportList(1, {industrycode2: this.industrycode2, feetype: this.feetype, datetime: this.datetime})
    },
    routedetails(innerid) {
      this.$parent.routerDetails(innerid)
    },
    ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>
<style lang="css" type="text/css">
    .mCS-dark.mCSB_scrollTools .mCSB_draggerRail {
      background-color: rgba(0,0,0,0);
    }
    .mCSB_scrollTools .mCSB_draggerContainer {
      right: -11px;
    }
    .mCS-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
      background-color: #ccc !important;
    }

    .mCS-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar, 
    .mCS-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_onDrag .mCSB_dragger_bar {
      background: #ccc !important;
    }
    .mCSB_inside > .mCSB_container {
      margin-right: 0;
    }
    
    .mCS-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {
      background: #ccc;
    }
    
</style>
<style lang="scss" type="text/scss" scoped>

.NewBg {
    float: left;
    width: 870px;
    min-width: 870px;

    

    .null {
      background: #fff;
      p {
          font-size: 14px;
          color: #CADAEE;
          text-align: center;
      }
      img {
          display: block;
          width: 115px;
          margin: auto;
          padding-top: 66px;
          margin-bottom: 20px;
      }
    }
    .screen {
      margin-top: 18px;
      font-size: 14px;
      .screen-head {
        padding: 5px 12px;
        background: #EEEEEE;
        span {
          color: #999999;
        }
        .el-button {
          margin-left: 20px;
          &.el-button--text {
            color: #333333;
          }
          &.active.el-button--text {
            color: #409EFF;
          }
        }
      }
      .screen-msg {
        position: absolute;
        z-index: 11;
        width: 870px;
        max-height: 158px;
        padding: 6px 0;
        // padding: 20px;
        padding-left: 0;
        box-sizing: border-box;
        overflow-x: auto;
        background: #F5F5F5;

        span {
          float: left;
          display: block;
          // margin-bottom: 12px;
          padding: 10px 0;
          cursor: pointer;
          margin-left: 20px;

          &:hover {
            color: #409EFF;
          }
        }
      }
    }
    .new-list {
      overflow-x: auto;
      max-height: 685px;
      padding-bottom: 20px;


      .new-item {
        margin-top: 10px;
        margin-left: 2px;
        margin-right: 8px;
        padding: 20px;
        overflow: hidden;
        cursor: pointer;

        &:hover {
          box-shadow:0px 0px 6px 0px rgba(0,0,0,0.1);
          border-radius:4px;
        }
          .bg-img {
            float: left;
            position: relative;
            img {
              position: relative;
              z-index: 2;
              width:169px;
              height:101px;
            }
            &::after {
              content: '';
              position: absolute;
              top: 0;
              display: block;
              width:176px;
              height:101px;
              background-image: url('./../../../../common/images/report/index/img_bg.png');
              background-size: 100%;
            }
          }
          .new-item_text {
            // margin-left: 28px;
            width: 616px;
            float: right;
            &:hover {
              .name {
                color: #409EFF;
              }
            }
            .name {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-break: break-all;
                font-size: 16px;
                font-weight:400;
                height: 20px; 
            }
            .msg {
              max-height: 40px;
              margin-top: 8px;
              // height: 40px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              word-break: break-all;
              font-size: 14px;
              line-height: 20px;
              color: #999;
            }

            .tag {
              margin-top: 20px;
              font-size: 12px;
              color: #999999;

              .type {
                display: inline-block;
                margin-right: 10px;
                width: 12px;
                height: 12px;
                background: url('./../../../../common/images/report/index/tag.png') center no-repeat;
                background-size: 100%;
                text-align: 10px;
                transform: translateY(1px);
                -webkit-transform: translateY(1px);
                -moz-transform: translateY(1px);
                -ms-transform: translateY(1px);
                -o-transform: translateY(1px);
              }
            }
          }
      }
    }
}
</style>